import { ClerkProvider, SignIn, SignedIn, SignedOut } from "@clerk/clerk-react";

import { useAppPartySocket } from "~/app/hooks/useAppPartySocket";

import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";

import { AnalyticsProvider } from "../Analytics/AnalyticsProvider";
import { UserIdentifier } from "../Analytics/UserIdentifier";
import { CallManager } from "../Call/CallManager";
import { NetworkStatusProvider } from "../NetworkStatus/NetworkStatusProvider";
import { ClerkAuthObserver } from "./ClerkAuthObserver";
import { useAuth } from "./UnifiedAuthProvider";

const POSTHOG_ENABLED = import.meta.env.VITE_POSTHOG_ENABLED;
const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

export function WebApp() {
  const { isAuthenticated } = useAuth();
  const partySocket = useAppPartySocket({ room: "waiting-room" });

  if (!CLERK_PUBLISHABLE_KEY) {
    throw new Error("VITE_CLERK_PUBLISHABLE_KEY is not set");
  }

  return (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <AnalyticsProvider
        posthogKey={POSTHOG_KEY}
        posthogEnabled={POSTHOG_ENABLED}
      >
        <NetworkStatusProvider>
          <TooltipProvider>
            <main className="min-h-screen" data-testid="app-loaded">
              <SignedIn>
                <ClerkAuthObserver />
                {isAuthenticated ? (
                  <>
                    <UserIdentifier />
                    <CallManager partySocket={partySocket} />
                  </>
                ) : (
                  <div className="flex min-h-screen items-center justify-center">
                    <p>Synchronizing authentication...</p>
                  </div>
                )}
              </SignedIn>
              <SignedOut>
                <div className="flex min-h-screen items-center justify-center">
                  <SignIn />
                </div>
              </SignedOut>
            </main>
          </TooltipProvider>
          <Toaster />
        </NetworkStatusProvider>
      </AnalyticsProvider>
    </ClerkProvider>
  );
}
